import type { AdvisorUiConfig } from '@blk/aw-bff-typescript-models';
import type { ClientConfigurationParams } from '../../../api/AWBffServer/UIConfigurations';
import { getQueryClient } from '../../queryClient';
import { uiConfigurationQuery } from '../queries';

/**
 * Fetch advisor configuration with TanStack Query caching.
 *
 * @param params - Configuration parameters (pkg, viewAs, configurationDirectory)
 */
export function getAWAdvisorConfiguration(params: ClientConfigurationParams): Promise<AdvisorUiConfig> {
  const queryClient = getQueryClient();

  return queryClient.fetchQuery(uiConfigurationQuery(params));
}
